import {
  Center,
  Container,
  Flex,
  Heading,
  Stack,
  Text,
  Image,
  Box,
} from '@chakra-ui/react'
import StageBookLogo from '@/assets/stagebook_logo.webp';
import EventBgImage from '@/assets/event_bg.png';

type Props = {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const AuthContainer = ({ children, title, subtitle }: Props) => (
  <Flex height="100vh" flex="1">
    <Box flex="1" hideBelow="lg">
      <Center w="full" h="full" bg="colorPalette.solid" color="colorPalette.contrast/60" overflow="hidden">
        <Image src={EventBgImage} alt="Login Background" objectFit="cover" height="100%" width="100%" />
      </Center>
    </Box>
    <Center flex="1.5" py={{ base: '24', md: '32' }}>
      <Container maxW="md">
        <Stack gap="8">
          <Flex justifyContent="center">
            <Image src={StageBookLogo} alt="StageBook Logo" width={180} />
          </Flex>

          <Stack gap={{ base: '2', md: '3' }} textAlign="center">
            {title && <Heading size="2xl">{title}</Heading>}
            {subtitle && <Text color="fg.muted">{subtitle}</Text>}
          </Stack>

          {children}
        </Stack>
      </Container>
    </Center>
  </Flex>
);

export default AuthContainer;
